"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PosaTemplate_1 = __importDefault(require("./PosaTemplate"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const RichTextStyled_1 = __importDefault(require("./RichTextStyled"));
const RichText = ({ data }) => {
    const { content } = data;
    if (!content)
        return null;
    return (react_1.default.createElement(RichTextStyled_1.default, { className: "ecr-rich-text" },
        react_1.default.createElement(PosaTemplate_1.default, { isTemplate: true, string: content })));
};
RichText.propTypes = {
    data: prop_types_1.default.object
};
exports.default = RichText;
//# sourceMappingURL=RichText.js.map